import { Modal } from 'antd';
import React, { useRef, useState, useEffect } from 'react';

interface Props {
  shippingAddressFromER?: string | null;
}

const ShippingAddressFromER: React.FC<Props> = ({ shippingAddressFromER }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(textRef.current.scrollHeight > 150);
    }
  }, [shippingAddressFromER]);

  if (!shippingAddressFromER) return null;

  return (
    <>
      <div style={{ marginTop: 15 }}>
        <p style={{ margin: '0 0 5px' }}>
          <b>Shipping Address from Email Reader</b>
        </p>
        <div
          ref={textRef}
          style={{
            maxHeight: isOverflowing ? 150 : undefined,
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <span>{shippingAddressFromER}</span>
          {isOverflowing && (
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                height: 40,
                background: 'linear-gradient(transparent, #dfe7ff)',
                pointerEvents: 'none',
              }}
            />
          )}
        </div>
        {isOverflowing && (
          <span
            style={{ color: '#23527c', cursor: 'pointer' }}
            onClick={() => setIsModalVisible(true)}
          >
            Show More
          </span>
        )}
      </div>

      <Modal
        title="Shipping Address from Email Reader"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={700}
      >
        <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
          {shippingAddressFromER}
        </div>
      </Modal>
    </>
  );
};

export default ShippingAddressFromER;
